import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import { Observable, isObservable } from 'rxjs';

@Component({
  selector: 'app-loading-page',
  templateUrl: './loading-page.component.html',
  styleUrl: './loading-page.component.scss'
})
export class LoadingPageComponent implements OnChanges {
  @Input() message: string | Observable<string> = 'Loading...'; // Accepts both string and Observable<string>
  @Input() option: 'option1' | 'option2' = 'option1'; // Default option
  @Input() isFullScreen: boolean = true; // Default to full screen

  animations = {
    option1: '/assets/animations/loading1.json',
    option2: '/assets/animations/loading2.json'
  };

  selectedAnimation: AnimationOptions = {
    path: this.animations[this.option]
  };

  displayMessage: string = ''; // Stores the actual message to display

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes[this.option] && changes[this.option].currentValue) {
      this.selectedAnimation = {
        path: this.animations[this.option]
      };
    }

    // If message is an Observable, subscribe to updates
    if (isObservable(this.message)) {
      (this.message as Observable<string>).subscribe(newMessage => {
        this.displayMessage = newMessage;
      });
    } else {
      this.displayMessage = this.message as string;
    }
  }
}
